import React from 'react';
import DelBox from '../comps/DelBox';
import AddDoctor from '../models/AddDoctor';
import AddTpa from '../models/AddTpa';

const TpaWorkload = () => {
    return (
        <div class="page-content">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-lg-12">
                        <div class="card" id="orderList">
                            <div class="card-header border-0">
                                <div class="row align-items-center gy-3">
                                    <div class="col-sm">
                                        <h5 class="card-title mb-0">Tpa Workload</h5>
                                    </div>

                                </div>
                            </div>
                            <div class="card-body border border-dashed border-end-0 border-start-0">
                                <form>
                                    <div class="row g-3">
                                        <div class="col-xxl-2 col-sm-6">
                                            <div class="search-box">
                                                <input class="form-control search" type="date" fdprocessedid="ws635j" />
                                            </div>
                                        </div>
                                        <div class="col-xxl-2 col-sm-6">
                                            <div class="search-box">
                                                <input class="form-control search" type="date" fdprocessedid="ws635j" />
                                            </div>
                                        </div>
                                        <div class="col-xxl-2 col-sm-6">
                                            <select class="form-control" data-trigger="" name="productname-field" id="productname-field">
                                            <option value="TPA 1">TPA 1</option>
                                            <option value="TPA 2">TPA 2</option>
                                            <option value="TPA 3">TPA 3</option>
                                            <option value="TPA 4">TPA 4</option>
                                            <option value="TPA 5">TPA 5</option>
                                            </select>
                                        </div>
                                        <div class="col-xxl-2 col-sm-6">
                                            <select class="form-control" data-trigger="" name="productname-field" id="productname-field">
                                                <option value="Paid">Paid</option>
                                                <option value="Unpaid">Unpaid</option>
                                            </select>
                                        </div>
                                        <div class="col-xxl-2 col-sm-6">
                                            <button type="button" class="btn btn-primary">Find</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <br />
                            <div class="card-body pt-0">
                                <div>

                                    <div class="table-responsive table-card mb-1">
                                        <table class="table table-nowrap align-middle" id="orderTable">
                                            <thead class="text-muted table-light" >
                                                <tr class="text-uppercase">
                                                    <th scope="col">
                                                        <div class="form-check">
                                                            <input class="form-check-input" id="checkAll" type="checkbox" value="option" />
                                                        </div>
                                                    </th>
                                                    <th data-sort="id">S. No.</th>
                                                    <th data-sort="customer_name">IPD Date</th>
                                                    <th data-sort="product_name">Bill Date</th>
                                                    <th data-sort="product_name">Bill No</th>
                                                    <th data-sort="product_name">IPD No</th>
                                                    <th data-sort="product_name">Patient</th>
                                                    <th data-sort="product_name">Panel</th>
                                                    <th data-sort="product_name">Bill Amt</th>
                                                    <th data-sort="product_name">Paid</th>
                                                    <th data-sort="product_name">P Date</th>
                                                </tr>
                                            </thead>
                                            <tbody class="list form-check-all">
                                                <tr>
                                                    <th scope="row">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox" value="option1" name="checkAll" />
                                                        </div>
                                                    </th>
                                                    <td class="customer_name">1.</td>
                                                    <td class="product_name">12-12-2025</td>
                                                    <td class="date">433545</td>
                                                    <td class="date">3434434435</td>
                                                    <td class="date">3434434435</td>
                                                    <td class="date">Jai Singh</td>
                                                    <td class="date">Panel 1</td>
                                                    <td class="date">15000</td>
                                                    <td class="date">10000</td>
                                                    <td class="product_name">12-12-2025</td>

                                                </tr>
                                            </tbody>
                                        </table>
                                        <div class="noresult">
                                            <div class="text-center">
                                                <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="loop" colors="primary:#405189,secondary:#0ab39c"></lord-icon>
                                                <h5 class="mt-2">Sorry! No Result Found</h5>
                                                <p class="text-muted">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end">
                                        <div class="pagination-wrap hstack gap-2">
                                            <a class="page-item pagination-prev disabled" href="#">Previous</a>
                                            <ul class="pagination listjs-pagination mb-0"></ul>
                                            <a class="page-item pagination-next" href="#">Next</a>
                                        </div>
                                    </div>
                                </div>
                                <AddTpa />
                                <DelBox />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TpaWorkload;
